export default {
  clues: 'Clue {id}',
  question: 'Question {id}',
  startQuiz: 'start quiz',
  nextClue: 'next clue',
  prevClue: 'prvious clue',
};
